// ------------------------------------------------------------------
// src/app.js
//
// The core app object for Reads.
//
// It binds the application together and makes general functionality
// available across all the components (like the filter). Components
// that should be available on every page should be included here.
//
// It manages application properties that are outside the scope of 
// the components (like page rendering and locale management)
//
// -------------------------------------------------------------------
"use strict";

const app = {

    // A jQuery reference to the DOM element that contains the entire application
    $el: $("#app-root"),
    
    // a reference to the current displayed page
    // Backbone.View
    currentPage: {},

    // Base components that will always be displayed on the page
    // Therefore is outside the base #app-root element because we 
    // do not want to re-render these on every route.
    components: {
        filters: {},
        footer: {},
        searchBar: {},
        nav: {},
    },

    // Flag to know if the app was initialized or not
    isInit: false,

    // initialized in bootstrap.js
    router: {},

    localeManager: {},

    // The language of the application
    // Can be toggled between fr and en
    locale: "en",

    // The supported languages in Reads
    // Used when initializing the routes
    supportedLanguages: ["en", "fr"],

    changeLanguage: function(lang) {
        if (lang === "fr" || lang === "en") {
            this.localeManager.switch(lang);
            this.locale = lang;

            // Calling render() calls jQuery.empty() under the hood
            // We need to bind the events again
            this.delegateComponentsEvents(this.currentPage);
            
            // Re-render all the base components
            for (let c in this.components) {
                if (this.components.hasOwnProperty(c)) {
					this.components[c].render();
                }
            }
        }
    },

    // Backbone.View.delegateEvents is called internally on the object creation (before initialize is called).
    // However we need to dispatch the events again when the component is re-rendered because the 
    // trigger element is removed from the DOM and cannot be listened to anymore.
    delegateComponentsEvents: function(component) {
        if (typeof(component.delegateEvents) === "function") {
            component.delegateEvents();
        }

        for (let c in component.components) {
            // We call delegateComponents recursively because components possess an unknown tree of sub-components
            if (component.components.hasOwnProperty(c)) {
				this.delegateComponentsEvents(component.components[c]);
            }
        }
    },

    display: function(page) {
        this.currentPage = page;
        this.$el.html(page.render().el);
        page.afterRender();
    },

    // Click, hover and other pointer-events are deactivated, but scrolling is still active
    disable: function() {
        this.components.nav.$el.css("pointer-events", "none");
        this.components.footer.$el.css("pointer-events", "none");
        this.$el.css("pointer-events", "none");
    },

    // Click, hover, other pointer-events and scrolling are disabled
    // Usually ran when a modal is open
    freeze: function() {
        // $("body, html").css({"overflow": "hidden"});
        this.components.nav.$el.css("pointer-events", "none");
        this.components.footer.$el.css("pointer-events", "none");
        this.$el.css("pointer-events", "none");
    },

    // Returns the currently selected language
    getLanguage() {
        return this.locale;
    },

    // Returns the list of supported languages in Reads
    getSupportedLanguages() {
      return this.supportedLanguages;
    },

    // Initializes the app
    init: function() {
        if (!this.isInit) {
            let $body = $("body");
            // Important: the LocaleManager needs to be initalized first because
            // the subcomponents require it
            this.localeManager = new LocaleManager(READS_LOCALE);

            this.components.filters = new BookFilterComponent();
            $body.append(this.components.filters.render().el);
            this.components.footer = new Footer();
            $body.append(this.components.footer.render().el);
            this.components.searchBar = new SearchBarComponent();
            $body.append(this.components.searchBar.render().el);
            this.components.nav = new TopNavView();
            $body.prepend(this.components.nav.render().el);
            // READS_LOCALE is defined in "src/locales/lang.js"
            this.isInit = true;
        }
    },
 
    // Click, hover and other pointer-events are activated
    resume: function() {
        // Important: instead of resetting the overflow property to auto we remove the style element
        // Otherwise the absolutely positioned elements will be anchored and act as a fixed element until
        // the overflow: auto disappears
        $("body, html").removeAttr("style");
        this.components.nav.$el.css("pointer-events", "all");
        this.components.footer.$el.css("pointer-events", "all");
        this.$el.css("pointer-events", "all");
    }
};